<template>
  <div class="sidebar-container">
    <el-menu
      mode="vertical"
      text-color="#5A5A5A"
      :default-active="defaultActive"
      :unique-opened="true"
      :default-openeds='defaultOpenedsArray'
      active-text-color="#231815"
      ref="menu"
    >
      <sidebar-item v-for="menu in menuList" :key="menu.id" :item="menu"/>
    </el-menu>
  </div>
</template>
<script>
import SidebarItem from './SidebarItem'
export default {
  name: 'Sidebar',
  components: { SidebarItem },
  data () {
    return {
      defaultOpenedsArray: [],
      defaultActive: null// 关键   当前激活菜单的 index
    }
  },
  watch: {
    $route () {
      this.setCurrentRoute()
    }
  },
  props: {
    menuList: {
      type: Array,
      required: true
    }
  },
  methods: {
    setCurrentRoute () {
      this.defaultActive = this.$route.query.id // 关键   通过他就可以监听到当前路由状态并激活当前菜单
    }
  },
  created () {
    this.setCurrentRoute()
  },
  mounted () {
    this.$bus.$on('closeNav1', () => {
      // console.log('收到了数据')
      this.defaultOpenedsArray = []
    })
  }
}
</script>
<style lang="scss">
.sidebar-container {
  transition: width 0.28s;
  bottom: 0;
  left: 0;
  z-index: 1001;
  overflow: hidden;
  margin-top: 280px;
  font-family: 'BasicCommercialW01-Roma'!important;
  //.el-zoom-in-top-enter-active, .el-zoom-in-top-leave-active, .collapse-transition {
  //  transition: 1s !important
  //}
  .horizontal-collapse-transition {
    transition: 0s width ease-in-out, 0s padding-left ease-in-out, 0s padding-right ease-in-out;
  }
  .el-scrollbar {
    height: 100%;
  }
  .scrollbar-wrapper {
    overflow-x: hidden!important;
    .el-scrollbar__view {
      height: 100%;
    }
  }
  .el-scrollbar__bar.is-vertical{
    right: 0px;
  }
  .is-horizontal {
    display: none;
  }
  a {
    display: inline-block;
    width: 100%;
    overflow: hidden;
  }
  .el-menu {
    border: none;
    height: 100%;
    width: 100% !important;
    background-color: transparent;
  }
  .el-submenu__title,.el-menu-item,.el-menu-item.is-active{
    font-size: 12px!important;
    letter-spacing: 2px;
  }
  .el-menu-item,.el-submenu__title{
    color: #000 !important;
    height: 30px!important;
    line-height: 30px!important;
  }
  .is-active > .el-submenu__title,.el-menu-item.is-active{
    font-weight: 800  !important;
    color: #000000 !important;
    font-family: 'BasicCommercialW01-Roma'!important;
    background-color: transparent!important;
  }
  .el-menu  .el-submenu__title,.el-menu .el-menu-item{
    padding-left: 0px!important;
    padding-right: 0!important;
    &:hover{
      background-color: transparent!important;
    }
    span:hover{
      border-bottom: 1px solid #000;
    }
  }
  .el-menu  .el-menu .el-submenu .el-submenu__title,.el-menu  .el-menu  .el-menu-item{
    padding-left: 20px!important;
  }
  .el-menu  .el-menu .el-menu .el-submenu__title,.el-menu  .el-menu .el-menu .el-menu-item{
    padding-left: 30px!important;
  }
  .el-menu  .el-menu .el-menu .el-menu .el-submenu__title,.el-menu  .el-menu .el-menu .el-menu .el-menu-item{
    padding-left: 40px!important;
  }
  .el-menu  .el-menu .el-menu .el-menu .el-menu .el-submenu__title,.el-menu  .el-menu .el-menu .el-menu .el-menu .el-menu-item{
    padding-left: 50px!important;
  }
  .el-menu  .el-menu .el-menu .el-menu .el-menu .el-menu .el-submenu__title,.el-menu .el-menu .el-menu .el-menu .el-menu .el-menu .el-menu-item{
    padding-left: 60px!important;
  }
  .el-menu  .el-menu .el-menu .el-menu .el-menu .el-menu .el-menu .el-submenu__title,.el-menu .el-menu .el-menu .el-menu .el-menu .el-menu .el-menu .el-menu-item{
    padding-left: 70px!important;
  }
  .el-submenu__title i {
    display: none;
  }
  //.el-menu-item.is-active::before{
  //  content: '';
  //  width: 15px;
  //  height: 1px;
  //  border-bottom: 3px solid #000;
  //  position: absolute;
  //  top: 25px;
  //  color: #000;
  //}
  span{
    //border-bottom: 1px solid #fff;
  }
  .el-menu-item.is-active span {
    border-bottom: 1px dotted #000;
  }
}
// .sidebar-container>.el-menu>div>.el-submenu:hover>.el-menu
// ,.sidebar-container>.el-menu>div>.el-submenu:hover>.el-menu>div>.el-submenu>.el-menu
// {
//   display: block!important;
//   transition: all 5s;
// }
//.sidebar-container>.el-menu>div>.el-submenu>.el-menu>div>.el-submenu:hover>.el-menu{
//  display: block!important;
// }
//.sidebar-container>.el-menu>div>.el-submenu>.el-menu>div>.el-submenu>.el-menu>div>.el-submenu:hover>.el-menu{
//  display: block!important;
//}
.sidebar-container>.el-menu>div>.el-submenu,.sidebar-container>.el-menu>div>.el-menu-item{
  display: inline-block;
}
</style>
